/**
 * G-9.2 kit: segmented control for small enumerable choices (analytics
 * period, role filters, vehicle filters). For multi-select filters use Chips
 * instead.
 *
 * `value` may be null — nothing picked yet. G-121 S3 needs exactly that: a
 * typed purchase price has no default side of IVA (OD-138), so the person
 * must tap one. A radiogroup with no checked radio is valid ARIA; every
 * caller that passes a value behaves as before.
 */
export function SegmentedControl<T extends string>({
  options,
  value,
  onChange,
  ariaLabel,
  disabled = false,
}: {
  options: Array<{ value: T; label: string }>;
  value: T | null;
  onChange: (next: T) => void;
  ariaLabel: string;
  disabled?: boolean;
}) {
  return (
    <div className="kit-segmented" role="radiogroup" aria-label={ariaLabel}>
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          role="radio"
          aria-checked={value === option.value}
          className={
            value === option.value ? "kit-segment is-selected" : "kit-segment"
          }
          onClick={() => onChange(option.value)}
          disabled={disabled}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
